function parseEnvFlag(value) {
  return String(value || '').trim().toLowerCase() === 'true';
}

export function isIntradayFeatureEnabled() {
  return parseEnvFlag(process.env.VUE_APP_INTRADAY_FEATURE);
}
